import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { ThemeProvider } from '@material-ui/core/styles';
import App from './App';
import reportWebVitals from './reportWebVitals';
import theme from './theme'
import 'react-image-lightbox/style.css';
import './fonts/AAutoSignatureFont/AAutoSignature-1GD9j.ttf';
import './fonts/AgreementSignature/AgreementSignature-qZX6x.ttf';
import './fonts/AuthorizedSignature/AuthorizedSignature-ZVOMx.ttf';
import './fonts/SundiaryFont/SundiaryDemo-2OgdK.ttf';
import './fonts/BreakFF/Break Regular.ttf';
import './fonts/Magnilda_Font/Magnilda 400.ttf';
import './fonts/Photograph_Signature/Photograph Signature 400.ttf';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
